import { Button, Modal } from 'react-bootstrap';

const PwaSignout = ({ show, onClick }) => {
  return (
    <Modal show={show} aria-labelledby='contained-modal-title-vcenter' centered>
      <Modal.Header>
        <Modal.Title id='contained-modal-title-vcenter'>
          Session Expired
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Your session has expired.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' size='sm' onClick={onClick}>
          Login
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PwaSignout;
